import { Component } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { trackEvent } from 'helpers/analytics';
import ImageLazyLoader from 'components/common/ImageLazyLoader';
import { SmallLoader } from 'components/Loader';
import { constructMSAImageUrl } from 'helpers';
import { isProductHearted, makeFavoriteHeartButton, makeHandleHeartButtonClick } from 'helpers/HeartUtils';
import css from 'styles/components/productdetail/dontForget.scss';
import DesktopSlider from 'components/common/DesktopSlider';

const imagePlaceholder = <div className={css.thumbnailPlaceholder} />;

const makePriceContainer = ({ basePrice, salePrice }) => {
  const onSale = basePrice !== salePrice;

  return (
    <span className={css.priceContainer}>
      <span className={cn(css.price, { [css.salePrice]: !!onSale })}>{salePrice}</span>
      {!!onSale && !!basePrice && (
        <div>
          <span className={css.originalPricePrefix}>MSRP: </span>
          <span className={css.originalPrice}>{basePrice}</span>
        </div>
      )}
    </span>
  );
};

class DontForget extends Component {
  /** returns an onClickReco function for the given reco */
  makeOnClickReco = productId => () => trackEvent('TE_PDP_DFRECO', productId)

  makeSlider = () => {
    const { makeRecos } = this;
    const imageEls = makeRecos();
    return <DesktopSlider slidesToShow={1} slideIndex={0} slidesToScroll={1}>{imageEls}</DesktopSlider>;
  }

  makeImages = index => {
    const {
      props: {
        product: {
          productName: productNameWithoutBrand,
          styles: productStyles,
          brandName
        }
      }
    } = this;
    const currentProductStyle = productStyles[index];
    const { mainImageId } = currentProductStyle;
    const imgProps = {
      src: constructMSAImageUrl(mainImageId, { height: 102, width: 136, autoCrop: true }),
      alt: `${brandName} ${productNameWithoutBrand}`,
      className: css.thumbnail
    };
    return <ImageLazyLoader imgProps={imgProps} placeHolder={imagePlaceholder}/>;
  }

  // TODO is this used? @rpacheco
  isHearted = styleId => {
    const { heartsData = {} } = this.props;
    const { showFavoriteHeart, hearts = [] } = heartsData;
    return isProductHearted(showFavoriteHeart, hearts, styleId);
  }

  makeFavoriteHeart = (style, productId) => {
    const { heartsData = {} } = this.props;
    const { showFavoriteHeart, hearts, heartsList } = heartsData;
    return makeFavoriteHeartButton({
      cssHeartContainer: css.heartContainer,
      cssHeartActive: css.heartActive,
      handleHeartClick: this.handleHeartClick,
      hearts,
      heartsList,
      productId,
      showFavoriteHeart,
      style
    });
  }

  handleHeartClick = (style, productId) => {
    const { heartsData = {} } = this.props;
    const { onHeartClick, showFavoriteHeart, hearts } = heartsData;
    return makeHandleHeartButtonClick({
      hearts,
      onHeartClick,
      productId,
      showFavoriteHeart,
      style
    });
  }

  makeRecos = () => {
    const {
      props: {
        product: {
          productName,
          styles: productStyles,
          brandName, productId
        }
      },
      makeImages,
      makeOnClickReco
    } = this;

    return productStyles.map((style, index) => {
      const { styleId, productUrl } = style;
      return (
        <Link
          key={styleId}
          to={productUrl}
          className={css.link}
          onClick={makeOnClickReco(productId)}>
          {makeImages(index)}
          {this.makeFavoriteHeart(style, productId)}
          <div className={css.brandName}>{brandName}</div>
          <div className={css.productNameWithoutBrand}>{productName}</div>
          {makePriceContainer(style)}
        </Link>
      );
    });
  }

  makeBody = () => {
    const { makeSlider } = this;
    return (
      <>
        <h2 className={css.heading}>Don't Forget...</h2>
        {makeSlider()}
      </>
    );
  }

  render = () => {
    const { props: { isLoading }, makeBody } = this;
    const body = isLoading ? <SmallLoader /> : makeBody();
    return <div id="dontForget" className={css.dontForget}>{body}</div>;
  }
}

DontForget.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  product: PropTypes.shape({
    productId: PropTypes.string.isRequired,
    brandName: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    styles: PropTypes.arrayOf(
      PropTypes.shape({
        mainImageId: PropTypes.string.isRequired,
        swatchId: PropTypes.string.isRequired,
        basePrice: PropTypes.string.isRequired,
        salePrice: PropTypes.string.isRequired,
        productUrl: PropTypes.string.isRequired
      }).isRequired
    ).isRequired
  })
};

export default DontForget;
